/* Add to basket from book cards. Works after AJAX filtering (event delegation). */
(() => {
  if (window.__mhbBookCard) return;
  window.__mhbBookCard = true;

  const updateCount = (count) => {
    const bubble = document.getElementById('cart-icon-bubble');
    if (!bubble) return;
    let badge = bubble.querySelector('[class*="__count"], .cart-count-bubble');
    if (!badge && count > 0) {
      badge = document.createElement('span');
      const base = (bubble.className.match(/(\S+)__action/) || [])[1];
      badge.className = base ? base + '__count' : 'cart-count-bubble';
      bubble.appendChild(badge);
    }
    if (!badge) return;
    if (count > 0) {
      badge.textContent = count;
      badge.setAttribute('aria-label', count + ' items');
    } else {
      badge.remove();
    }
  };

  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('[data-book-add]');
    if (!form) return;
    e.preventDefault();

    const btn = form.querySelector('button');
    const text = btn.querySelector('.book-card__btn-text');
    const original = text.textContent;
    btn.disabled = true;
    btn.classList.add('is-loading');

    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    try {
      const res = await fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: form.id.value, quantity: 1 })
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.description || data.message || 'Could not add');

      const cart = await (await fetch(root + 'cart.js')).json();
      updateCount(cart.item_count);
      document.dispatchEvent(new CustomEvent('mhb:cart-updated', { detail: cart }));

      btn.classList.remove('is-loading');
      btn.classList.add('is-added');
      text.textContent = 'Added ✓';
      setTimeout(() => {
        btn.classList.remove('is-added');
        text.textContent = original;
        btn.disabled = false;
      }, 2200);
    } catch (err) {
      btn.classList.remove('is-loading');
      text.textContent = /sold out|already/i.test(err.message) ? 'No more in stock' : 'Try again';
      setTimeout(() => {
        text.textContent = original;
        btn.disabled = false;
      }, 2500);
    }
  });
})();